import React, { useEffect } from 'react';
import { Alert } from '@mui/material';
import useStore from '../../states/store';

export default function Unauthenticated() {
  const reset = useStore((state) => state.reset);

  useEffect(() => {
    reset();

    setTimeout(() => {
      window.location.href = '/';
    }, 5000);
  });
  return (
    <Alert severity='error'>
      <strong>Unauthenticated / Expired Token</strong> user you will be redirected to login in 5
      seconds or click the link to <a href='/'>Login</a>.
    </Alert>
  );
}
